import { Box, Link } from '@mui/material';
import React, { useState } from 'react';
import { capitalize } from 'lodash-es';
import { ButtonV2 } from 'components/common/ui';
import { ModalFooter, ModalV2 } from 'components/common/modals';

import { PermissionsGate } from 'components/common';
import AddContractModal from '../AddContractModal/AddContractModal';
import styles from './signingContractDetails.style';

export default function SigningContractDetailsSection({
  subscriptionContracts,
  onGetSubscriptionAndContracts,
  subscriptionId,
}) {
  const [openContractModal, setOpenContractModal] = useState(false);

  const [showContractWarning, setShowContractWarning] = useState(false);
  const handleCloseContractModal = () => {
    setOpenContractModal(false);
  };
  const handleOpenContractModal = () => {
    if (subscriptionContracts && subscriptionContracts.length > 0) {
      setShowContractWarning(true);
    } else {
      setOpenContractModal(true);
    }
  };
  const handleConfirmCreateContract = () => {
    setShowContractWarning(false);
    setOpenContractModal(true);
  };
  const handleCancelCreateContract = () => {
    setShowContractWarning(false);
  };

  return (
    <Box style={styles.container}>
      <ButtonV2 size="small" onClick={handleOpenContractModal}>
        + Create Contract
      </ButtonV2>
      {!!subscriptionContracts?.length &&
        subscriptionContracts.map((contract, index) => (
          <Box sx={styles.contractWrapper} key={contract.id}>
            <Box sx={styles.contractRow}>
              <Box sx={styles.title}>Contract {index + 1}</Box>
            </Box>
            <Box sx={styles.contractRow}>
              <Box sx={styles.contractLabel}>Contract ID</Box>
              <Link
                href={`https://app.getaccept.com/document/edit/${contract.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {contract.id}
              </Link>
            </Box>
            <Box sx={styles.contractRow}>
              <Box sx={styles.contractLabel}>Contract Status</Box>
              <Box>{capitalize(contract.meta.status)}</Box>
            </Box>
            <Box sx={styles.contractRow}>
              <Box sx={styles.contractLabel}>Selected Template</Box>
              <Box>{contract.meta.templateName}</Box>
            </Box>
          </Box>
        ))}

      <PermissionsGate>
        <>
          <ModalV2
            isOpen={showContractWarning}
            onClose={handleCancelCreateContract}
            maxWidth="xs"
          >
            A contract has already been created for this subscription. Are you
            sure you want to create another one?
            <ModalFooter>
              <ButtonV2 onClick={handleCancelCreateContract} variant="outlined">
                Cancel
              </ButtonV2>
              <ButtonV2 onClick={handleConfirmCreateContract} autoFocus>
                Create another contract
              </ButtonV2>
            </ModalFooter>
          </ModalV2>
          <AddContractModal
            open={openContractModal}
            subscriptionId={subscriptionId}
            onGetSubscriptionAndContracts={onGetSubscriptionAndContracts}
            onClose={handleCloseContractModal}
          />
        </>
      </PermissionsGate>
    </Box>
  );
}
